import { Component } from "@angular/core";

@Component({
  selector: 'col[app-dt-col]',
  standalone: true,
  template: '',
  styleUrls: ['dt-col.component.scss'],
})
export class DtColComponent {}
